<template>
  <el-aside class="aside borde">
    <div @click="home" v-if="this.$route.path !== '/es/seleccionar-roles' && $store.getters.isLoggedIn">
      <br />
      <img src="@/assets/dashboard_personal.svg" width="30px" />
      <br />
      <span>{{$t('Dashboard Personal')}}</span>
    </div>
    <div @click="changeRole" v-if="this.$route.path !== '/es/seleccionar-roles' && $store.getters.isLoggedIn">
      <br />
      <img src="@/assets/transfer.svg" width="30px" />
      <br />
      <span>{{$t('Cambio de Rol')}}</span>
    </div>
    <!-- <div @click="dashboard">
      <br />
      <img src="@/assets/dashboard.svg" width="30px" />
      <br />
      <span>{{$t('Dashboard / Tablero')}}</span>
    </div> -->
    <div @click="inventory" v-if="this.$route.path !== '/es/seleccionar-roles' && $store.getters.isLoggedIn">
      <br />
      <img src="@/assets/list.svg" width="30px" />
      <br />
      <span>{{$t('Inventarios')}}</span>
    </div>
    <div @click="riesgos" v-if="this.$route.path !== '/es/seleccionar-roles' && $store.getters.isLoggedIn">
      <br />
      <img src="@/assets/riesgos.svg" width="30px" />
      <br />
      <span>{{$t('Riesgos Transversales')}}</span>
    </div>
    <div @click="areas" v-if="isAdmin() && this.$route.path !== '/es/seleccionar-roles'">
      <br />
      <img src="@/assets/areas.svg" width="30px" />
      <br />
      <span>{{$t('Áreas')}}</span>
    </div>
    <div @click="empresas" v-if="isAdmin() && this.$route.path !== '/es/seleccionar-roles'">
      <br />
      <img src="@/assets/empresas.svg" width="30px" />
      <br />
      <span>{{$t('Empresas')}}</span>
    </div>
    <div @click="usuarios" v-if="isAdmin() && this.$route.path !== '/es/seleccionar-roles'">
      <br />
      <img src="@/assets/employees.svg" width="30px" />
      <br />
      <span>{{$t('Usuarios')}}</span>
    </div>
    <div @click="contratos" v-if="isAdmin() && this.$route.path !== '/es/seleccionar-roles'">
      <br />
      <img src="@/assets/contratos.svg" width="30px" />
      <br />
      <span>{{$t('Contratos')}}</span>
    </div>
    <div @click="flujos" v-if="this.$route.path !== '/es/seleccionar-roles'">
      <br />
      <img src="@/assets/flujos.svg" width="30px" />
      <br />
      <span>{{$t('Flujos')}}</span>
    </div>
    <!--div @click="tutorial()">
      <br>
      <img src="@/assets/graduation.svg" width="30px">
      <br>
      <span>{{$t('Tutorial')}}</span>
    </div>
    <div @click="procedimientos()">
      <br>
      <img src="@/assets/organize.svg" width="30px">
      <br>
      <span>{{$t('Procedimientos especificos')}}</span>
    </div-->
  </el-aside>
</template>

<script>
export default {
  data() {
    return {
      window,
      select: null
    };
  },
  computed: {
    role() {
      return this.$store.getters.role || {};
    },
    user() {
      return this.$store.getters.user || {};
    },
    mel() {
      return this.role.faena_id === "5a6f78337b772dcfe68241d5";
    }
  },
  watch: {
    select(newVal, oldVal) {
      if (newVal.tagName !== "DIV") {
        newVal.parentElement.classList.add("selected");
      } else {
        newVal.classList.add("selected");
      }
      if (oldVal) {
        if (oldVal.tagName === "DIV") {
          oldVal.classList.remove("selected");
        } else {
          oldVal.parentElement.classList.remove("selected");
        }
      }
    }
  },
  methods: {
    isAdmin() {
      if (!this.$store.getters.role) return false;
      return this.$store.getters.role.admin || false;
    },
    home(event) {
      this.select = event.target;
      this.$router.push({ name: "dashboardPersonal" });
    },
    dashboard(event) {
      this.select = event.target;
      if (
        window.location.hostname === "release.bhp.lifeon.cl"
      ) {
        window.location = "https://dashboard.release.bhp.lifeon.cl";
      }
      if (window.location.hostname === "bhp.lifeon.cl") {
        window.location = "https://dashboard.inventarios.bhp.lifeon.cl";
      }
    },
    areas(event) {
      this.select = event.target;
      this.$router.push("/admin/areas");
    },
    empresas(event) {
      this.select = event.target;
      this.$router.push("/admin/empresas");
    },
    usuarios(event) {
      this.select = event.target;
      this.$router.push("/admin/usuarios");
    },
    contratos(event) {
      this.select = event.target;
      this.$router.push("/admin/contratos");
    },
    riesgos(event) {
      this.select = event.target;
      this.$router.push("/admin/riesgos-estandarizados");
    },
    flujos(event) {
      this.select = event.target;
      this.$router.push("/admin/workflows");
    },
    importacion(event) {
      this.select = event.target;
      this.$router.push("/admin/import");
    },
    reportes(event) {
      this.select = event.target;
      this.$router.push("/admin/reports");
    },
    inventory(event) {
      this.select = event.target;
      this.$router.push({ name: "inventorySelectPage" });
    },
    changeRole(event) {
      this.select = event.target;
      this.$router.push({ name: "SelectRoles" });
    },
    tutorial(event) {
      this.select = event.target;
    },
    procedimientos(event) {
      this.select = event.target;
      this.$router.push({ name: "procedures" });
    }
  }
};
</script>


<style scoped>
.aside {
  text-align: center;
  min-height: 100vh;
  background-color: #07758D;
  width: 105px !important;
}

.aside span {
  color: white;
  font-size: 12px;
  font-weight: bold;
}

.aside div {
  padding: 7px;
  color: white;
  font-size: 11px;
  font-weight: bold;
  cursor: pointer;
}

.aside img {
  margin-bottom: 8px;
}

.aside :hover {
  background-color: #3fa7bf;
}
.selected {
  background-color: #3fa7bf;
}
</style>
